import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge, MantineColor } from '@any-ui-react/core';
import { TOptions } from 'i18next';

export interface StatusPillowProps {
  asText?: boolean;
  color?: MantineColor;
  i18nKey?: string;
  icon?: ReactNode;
  i18nOptions?: TOptions;
}
export const StatusPillow = ({ asText, color, i18nKey, icon, i18nOptions }: StatusPillowProps) => {
  const { t } = useTranslation('shared');

  if (asText)
    return (
      <div className="flex items-center">
        {icon}
        <span className="text-2xs">{t(i18nKey || '', { ns: 'shared', ...i18nOptions })}</span>
      </div>
    );

  return (
    <Badge leftSection={icon} color={color}>
      <span className="text-2xs">{t(i18nKey || '', { ns: 'shared', ...i18nOptions })}</span>
    </Badge>
  );
};
